'use client'

import { Box, Button, CloseIcon, Drawer, Typography } from '@hermes/web-components'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { TuneRounded } from '@mui/icons-material'
import { MobileFilterBody, FilterDrawerHeader } from 'containers/Search/SearchPage.styles'
import React, { useState } from 'react'

/* TODO: does not need to be for filter only. Convert to full on drawer */
export const FilterDrawer = ({ children, ...props }: { children: React.ReactNode; [key: string]: any }) => {
  const { t } = useTranslateMessage()
  const [menuOpen, setMenuOpen] = useState<boolean>()
  return (
    <Box {...props}>
      <Drawer
        open={menuOpen}
        anchor="left"
        PaperProps={{
          sx: {
            maxWidth: '600px',
            width: '90%',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
          }
        }}
        ModalProps={{ keepMounted: true }}
        onClose={() => setMenuOpen(false)}
      >
        <FilterDrawerHeader>
          <Typography variant="h4">{t({ id: 'common.filter' })}</Typography>
          <Button onClick={() => setMenuOpen(false)} variant="ghost">
            <CloseIcon width="25px" />
          </Button>
        </FilterDrawerHeader>
        <MobileFilterBody>{children}</MobileFilterBody>
      </Drawer>
      <Box sx={{ zIndex: '998', position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)' }}>
        <Button
          onClick={() => setMenuOpen(true)}
          variant="outlined"
          startIcon={<TuneRounded />}
          sx={{
            zIndex: '999',
            bgcolor: 'white',
            boxShadow: 3
          }}
        >
          {t({ id: 'common.filter', defaultMessage: 'Filter' })}
        </Button>
      </Box>
    </Box>
  )
}
